import { render, staticRenderFns } from "./VideoComponent.vue?vue&type=template&id=a1a74a0a&scoped=true"
import script from "./VideoComponent.vue?vue&type=script&lang=ts"
export * from "./VideoComponent.vue?vue&type=script&lang=ts"
import style0 from "./VideoComponent.vue?vue&type=style&index=0&id=a1a74a0a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1a74a0a",
  null
  
)

export default component.exports